export const LeftArrowSvg = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.17859 10.0001L13.5784 4.60034C13.9038 4.27491 13.9038 3.74727 13.5784 3.42183L13.4016 3.24505C13.0761 2.91962 12.5485 2.91962 12.2231 3.24505L5.46802 10.0001L12.2231 16.7552C12.5485 17.0806 13.0761 17.0806 13.4016 16.7552L13.5784 16.5784C13.9038 16.253 13.9038 15.7253 13.5784 15.3999L8.17859 10.0001Z'
      fill='black'
    />
  </svg>
)

export const TopArrowSvg = (<svg
  xmlns='http://www.w3.org/2000/svg'
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
>
  <path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M7.85413 6.68876L3.53432 11.0086C3.27397 11.2689 2.85186 11.2689 2.59151 11.0086L2.45009 10.8672C2.18974 10.6068 2.18974 10.1847 2.45009 9.92435L7.85413 4.5203L13.2582 9.92434C13.5185 10.1847 13.5185 10.6068 13.2582 10.8672L13.1168 11.0086C12.8564 11.2689 12.4343 11.2689 12.1739 11.0086L7.85413 6.68876Z'
    fill='black'
  />
</svg>)